import { Button, Container, Form, Modal, Table } from 'react-bootstrap';
import { GoDiffAdded, GoTrashcan } from 'react-icons/go';

import styles from './MedicamentosAtencaoBasica.module.css';

const MedicamentosAtencaoBasica = props => {
  return (
    <Container className={styles.container_medicamentos}>
      <Table responsive striped bordered hover variant="dark">
        <thead>
          <tr>
            <th style={{ width: '55%' }}>Medicamentos Atenção Básica</th>
            <th style={{ width: '15%' }}>Qtde</th>
            <th style={{ width: '30%' }}>Ação</th>
          </tr>
        </thead>

        <tbody>
          {props.medicamentosAtencaoBasica.map((item, index) => {
            return (
              <tr key={`${item.nome}-${index}`}>
                <td>
                  <Form.Group controlId="medicamento">
                    <Form.Select
                      required
                      name="medicamento"
                      onChange={e => props.handleMedicamentosAtencaoBasica(index, 'medicamento', e.target.value)}
                      value={props.medicamentosAtencaoBasica[index].medicamento}
                    >
                      <option value=""></option>
                      {props.listaAtencaoBasica.map(item => (
                        <option key={item.id} value={item.nome}>{item.nome}</option>
                      ))}
                    </Form.Select>
                  </Form.Group>
                </td>
                <td>
                  <Form.Group controlId="quantidade">
                    <Form.Control
                      autoComplete="new-off"
                      required
                      type="number"
                      step="1"
                      name="quantidade"
                      onChange={e => props.handleMedicamentosAtencaoBasica(index, 'quantidade', e.target.value)}
                      value={props.medicamentosAtencaoBasica[index].quantidade}
                    />
                  </Form.Group>
                </td>
                <td>
                  <div className={styles.container_buttons}>
                    <Button
                      variant="warning"
                      id="deleteTableRow"
                      onClick={e => props.handleRemoveMedicamentoAtencaoBasica(index)}
                    >
                      <div className={styles.icon_container}>
                        <GoTrashcan className={styles.icon_trash} />Excluir
                      </div>
                    </Button>

                    <Button
                      variant="flat" className={styles.btn}
                      id="addTableRow"
                      onClick={props.handleAddMedicamentoAtencaoBasica}
                    >
                      <div className={styles.icon_container}>
                        <GoDiffAdded className={styles.icon_trash} />Incluir
                      </div>
                    </Button>
                  </div>
                    <Modal show={props.showModal} onHide={props.handleModalClose}>
                      <Modal.Header closeButton>
                        <Modal.Title>Excluir Medicamento</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>Tem certeza que deseja excluir esse medicamento?</Modal.Body>
                      <Modal.Footer>
                        <Button variant="secondary" onClick={props.handleModalClose}>
                          Não
                        </Button>
                        <Button variant="flat" className={styles.btn} onClick={e => props.handleRemoveMedicamentoAtencaoBasica(index)}>
                          Sim
                        </Button>
                      </Modal.Footer>
                    </Modal>
                </td>
              </tr>
            );
          })}
        </tbody>

        <tfoot>
          <tr>
            {props.medicamentosAtencaoBasica.length <= 0 && (
              <td colSpan="6">
                <div className="text-center">
                  <Button
                    variant="flat" className={styles.btn}
                    style={{ padding: '0 16px 0 16px' }}
                    id="addTableRow"
                    onClick={props.handleAddMedicamentoAtencaoBasica}
                  >
                    <GoDiffAdded className={styles.icon_trash} />Incluir
                  </Button>
                </div>
              </td>
            )}
          </tr>
        </tfoot>
      </Table>
    </Container>
  );
};

export default MedicamentosAtencaoBasica;
